import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

// App component with providers
import App from './App'

// Router and Styles
import createMainAppRouter from './router'
import './index.css'

const queryClient = new QueryClient()

// Create router instance
const router = createMainAppRouter();

// Debug logging
console.log('🚀 ===== MAIN APP DEBUG =====');
console.log('🚀 Environment VITE_BASE_URL:', import.meta.env.VITE_BASE_URL);
console.log('🚀 Environment VITE_APP_ENV:', import.meta.env.VITE_APP_ENV);
console.log('🚀 Router created:', router);
console.log('🚀 Current window.location:', window.location);
console.log('🚀 ===== END MAIN APP DEBUG =====');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App>
        <RouterProvider router={router} />
      </App>
    </QueryClientProvider>
  </React.StrictMode>,
) 